import { gql } from 'urql'

export const queryEvaluationMilestonesByDossierId = gql`
  query ($dossierId: Int!) {
    evaluation_milestone(where: { dossier_id: { _eq: $dossierId } }, order_by: { date: desc }) {
      id
      dossier_id
      title
      additional_title
      date
      status
    }
  }
`
export const upsertEvaluationMilestoneMutation = gql`
  mutation ($object: evaluation_milestone_insert_input!) {
    insert_evaluation_milestone_one(
      object: $object
      on_conflict: {
        constraint: evaluation_milestone_pk
        update_columns: [title, additional_title, date, status, description]
      }
    ) {
      id
    }
  }
`

export const queryEvaluationMilestoneSecondaryInfoById = gql`
  query ($evaluationMilestoneId: Int!) {
    evaluation_milestone_by_pk(id: $evaluationMilestoneId) {
      description
    }
  }
`

export const queryEvaluationMilestoneById = gql`
  query ($id: Int!) {
    evaluation_milestone_by_pk(id: $id) {
      id
      dossier_id
      title
      additional_title
      date
      status
      description
    }
  }
`

export const deleteEvaluationMilestoneByIdMutation = gql`
  mutation ($id: Int!) {
    delete_evaluation_milestone_by_pk(id: $id) {
      id
    }
  }
`

export const fetchEvaluationMilestoneFileUUIDsQuery = gql`
  query ($evaluationMilestoneId: Int!) {
    file(
      where: { _and: { entity_id: { _eq: $evaluationMilestoneId }, entity_type: { _eq: "EVALUATION_MILESTONE" } } }
    ) {
      uuid
    }
  }
`
